import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth/auth.service';

@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.scss']
})
export class MyAccountComponent implements OnInit {
  get usuario(){
    return this.authService.usuario;
  }

  constructor(private authService: AuthService) { }

  ngOnInit() {
  }

  logout(){
    localStorage.removeItem("data");
  }

}
